import { Button } from "@/components/Button";
import { faCaretRight } from "@fortawesome/pro-solid-svg-icons";

const OnboardingLink = ({
  title,
  url,
  external,
}: IMatConfigurationLinkProperty) => {
  if (external) {
    return (
      <Button
        variant="link"
        as="a"
        href={url}
        target="_blank"
        icon={faCaretRight}
        iconPosition="end"
        iconClassName="h-20 w-20">
        {title}
      </Button>
    );
  }

  return (
    <Button
      variant="link"
      as="link"
      to={url}
      icon={faCaretRight}
      iconPosition="end"
      iconClassName="h-20 w-20">
      {title}
    </Button>
  );
};

export default OnboardingLink;
